import { keepPreviousData, queryOptions } from "@tanstack/react-query"
import { z } from "zod"
import { PROJECT_STATUSES } from "@/features/project-status/core/projectStatus"
import { reportsQueryKeys } from "@/lib/queryKeys"
import {
  getBuyingComparisonReport,
  type BuyingComparisonParams,
} from "../../server/buyingComparisonServer"

export const BuyingComparisonSearchParams = z.object({
  status: z.enum(PROJECT_STATUSES).optional(),
  countryIds: z.array(z.string()).optional(),
  pageIndex: z.coerce.number().int().min(0).optional(),
  pageSize: z.coerce.number().int().min(1).max(200).optional(),
})

export type BuyingComparisonSearchValues = z.infer<typeof BuyingComparisonSearchParams>

export const BUYING_COMPARISON_DEFAULTS = {
  status: "approved" as const,
  pageIndex: 0,
  pageSize: 25,
}

export const applyBuyingComparisonDefaults = (
  s: BuyingComparisonSearchValues,
): BuyingComparisonParams => ({
  status: s.status ?? BUYING_COMPARISON_DEFAULTS.status,
  countryIds: s.countryIds,
  pageIndex: s.pageIndex ?? BUYING_COMPARISON_DEFAULTS.pageIndex,
  pageSize: s.pageSize ?? BUYING_COMPARISON_DEFAULTS.pageSize,
})

export const buyingComparisonQuery = (params: BuyingComparisonParams) =>
  queryOptions({
    queryKey: reportsQueryKeys.buyingComparison(params),
    queryFn: () => getBuyingComparisonReport({ data: params }),
    placeholderData: keepPreviousData,
  })
